
<div class="row g-3 m-0 mb-4 pb-3 pt-0 report-statistics">
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-1">
      <h2>Total Room Rate</h2>
      <h1>{{revenueTtl | currency:'USD':'symbol':'1.0-0'}}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-2">
      <h2>Average Room Rate</h2>
      <h1>{{revenuePNTAvg | currency:'USD':'symbol':'1.0-0'}}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-3">
      <h2>Reservations</h2>
      <h1>{{numResTTL}}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-4">
      <h2>Nights</h2>
      <h1>{{numNtsGuestTTL }}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-5">
      <h2>Average Nights</h2>
      <h1>{{numNtsGuestAVG  | number : '1.2-2'}}</h1>
    </div>
  </div>
  <div class="col-lg-2 col-md-4 col-sm-6">
    <div class="statistics bg-6">
      <h2>Properties</h2>
      <h1>{{this.resRevMaster[0]?.activeProperties}}</h1>
    </div>
  </div>
</div>
<div class="row">
  <p>Statistics based on sales date, not checkin date</p>
</div>
